module.exports = __webpack_public_path__ + "static/media/LoginRequest.2dc4a69d.png";